module.exports = __webpack_public_path__ + "static/img/thumb_21.6a25855.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_21.jpg
// module id = d5dP
// module chunks = 0